<template>
    <div v-touch:swipe.bottom="swipeBottomHandler">
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="container py-0" style="margin-bottom: 6rem!important;">
                <div class="row row-grid align-items-center">
                    <div class="col-12" style="text-align: center!important; padding: 0px!important; margin: 0.75rem!important; padding-top: 1.5rem;">
                        <h2 class="display-3 text-white">Tutorial</h2>
                        <p class="lead text-white" style="padding: 10px;">Watch the video below for instructions.</p>
                    </div>
                    <div class="col-12" style="text-align: center!important;">
                        <youtube-media player-width="auto" player-height="auto" video-id="qlX7kG7EiOk"></youtube-media>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "tutorial",
  components: {},
  methods: {
    swipeBottomHandler() {
      this.$router.go(-1)
    },
  },
};
</script>
